export default __webpack_public_path__ + "static/media/miscellanous.5b6dde42.svg";